import L from "leaflet";

export const convertToLatLng = (coords) =>
  coords?.map((coord) => coord.map((c) => [c[1], c[0]]));

export const latlngFromArrayToLatLng = (coords) =>
  coords ? L.GeoJSON.coordsToLatLngs(...coords) : undefined;
